import config from 'config';
import cuiData from './data-providers';
import apiService from './api-services';
import filters from './filters';
import layoutComponents from './layout-components';
import pages from './pages';
import appRoutes from './cui-routes';
import marketplace from './pages/marketplace';
import openShop from './pages/open-shop';
import cobrand from './pages/cobrand';
import facebookAuth from './layout-components/account/facebook-auth/facebook-auth';
import sentryConfigWithFilters from './sentry-filter';
import Analytics from './analytics';

Raven
  .config(config.ErrorReporting.sentryURI, sentryConfigWithFilters(config.ErrorReporting.sentryConfig))
  .addPlugin(Raven.Plugins.Angular, angular)
  .install();

angular.module('cui', [
    'cui.data',
    'cui.apiServices',
    'cui.filters',
    'cui.layoutComponents',
    'cui.pages',
    'cui.marketplace',
    'cui.openShop',
    'cui.cobrand',
    'ui.router',
    'ui.bootstrap',
    'ui.validate',
    'ui.mask',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngRaven',
    'jcf',
    'rzModule',
    'angular-md5',
    'credit-cards',
    'ngAria',
  ])
  .config(appRoutes)
  .run(['$window', '$location', '$rootScope', function($window, $location, $rootScope, analytics = new Analytics()) {

    function _historyApiAvailable() {
      return $window.history && $window.history.pushState && $window.history.replaceState;
    }

    function _inTestMode() {
      return !!navigator.userAgent.indexOf('PhantomJS') && config.Environment !== 'Production';
    }

    if (!_inTestMode() && !_historyApiAvailable() && $location.path().indexOf('unsupported-browser') === -1) {
      $window.location.href = '/unsupported-browser';
      throw 'Unsupported Browser';
    }

    $rootScope.$on('$stateChangeSuccess', function(e, to, toParams, from, fromParams) {
      if (!_inTestMode()) $window.scrollTo(0, 0);

      analytics.pageView(to);
    })

    if ($window.paypal) {
      $window.paypal.checkout.setup(config.PayPal.merchantID, {
        environment: config.PayPal.environment,
        container: 'main',
        buttons: [{
          button: 'paypal'
        }]
      });
    }
  }]);

facebookAuth();


// WEBPACK FOOTER //
// ./source/client/cui-app.js